import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MapPin, AlertTriangle, Loader2 } from "lucide-react";
import api from "../services/api";

export const DeliveryAddressBox = ({ onReady }) => {
  const [addr, setAddr] = useState(undefined);
  useEffect(() => {
    api.get("/addresses").then(({ data }) => { const a = data.find((x) => x.is_default) || data[0] || null; setAddr(a); onReady?.(!!a); }).catch(() => { setAddr(null); onReady?.(false); });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  if (addr === undefined) return <div className="flex items-center gap-2 text-[13px] text-slate-500 py-2"><Loader2 size={14} className="animate-spin" /> Adresse de livraison…</div>;
  if (!addr) {
    return (
      <div data-testid="delivery-address-missing" className="rounded-xl border border-amber-800/60 bg-amber-950/30 px-4 py-3 text-[13px] text-amber-200 flex items-start gap-2">
        <AlertTriangle size={16} className="shrink-0 mt-0.5" />
        <div>Ajoutez une adresse de livraison pour payer. <Link to="/compte?section=addresses" className="underline font-semibold text-white hover:text-[#FF3B3B]" data-testid="delivery-address-add">Ajouter mon adresse</Link></div>
      </div>
    );
  }
  return (
    <div data-testid="delivery-address" className="rounded-xl border border-[#222735] bg-[#08090C] px-4 py-3 text-[13px] flex items-start gap-3">
      <MapPin size={16} className="text-[#FF3B3B] shrink-0 mt-0.5" />
      <div className="min-w-0 flex-1">
        <div className="text-[11px] uppercase tracking-wider text-slate-500 font-bold">Livraison à</div>
        <div className="text-slate-50 font-semibold truncate">{addr.full_name}</div>
        <div className="text-slate-300 truncate">{addr.street}, {addr.zip} {addr.city}</div>
      </div>
      <Link to="/compte?section=addresses" className="text-[12px] text-slate-400 hover:text-white underline shrink-0" data-testid="delivery-address-change">Modifier</Link>
    </div>
  );
};

export default DeliveryAddressBox;
